import { render, staticRenderFns } from "./indexPlaceholder.vue?vue&type=template&id=cfb7b270&scoped=true&"
import script from "./indexPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./indexPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./indexPlaceholder.vue?vue&type=style&index=0&id=cfb7b270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb7b270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
